import './fieldText.css'
import React from "react";
import img_immatriculation from '../../img/immatriculation.png'

export default class FieldText extends React.Component {

        constructor(props) {
            super(props);
            this.state = {
                current:props.container.devis.params[props.field] || ''
            }
            this.ref = React.createRef()
        }
/*
        componentDidUpdate(prevProps, prevState) {
            const prevValue = prevProps.container.devis.params[prevProps.field] || ''
            const value = this.props.container.devis.params[this.props.field] || ''
            if ( prevValue != value ) {
                this.setState({current:value})
            }
        }
*/
        render() {
    
            const me = this
            const {devis,changeParams,showValidate,focusError} = this.props.container
            const {field,notice,noCheck,placeholder,logo,logoClass} = this.props
            let message = devis.validateMessage(field)
            if ( message && !noCheck ) focusError(this.ref)
            if ( !showValidate ) message = undefined
    
            const displayer = devis.getDisplayer(field)
            const storer = devis.getStorer(field)

            const label = this.props.label || devis.getLabel( field )
            const updater = this.props.updater

            /*
                        onBlur={ e => {
                            changeParams({[field]:this.state.current})
                        } } */
            return <><h3>{label}</h3>
                    {notice?<span className="notice">{notice}</span>:<></>}
                    <div ref={this.ref} className={'front_form_row'+(message?' invalidbox':'')}>
                    { logo ? <img src={logo} className={logoClass ?( 'logo '+logoClass ): 'logo'}/> : <></> }
                    <input className={ logo ? 'text_input with_logo' : 'text_input'} type="text" value={displayer(this.state.current)} 
                        placeholder={placeholder}
                        onChange={ e => {
                            const value = updater ? updater(e.target.value) : e.target.value
                            this.setState({current:storer(value)})
                            setTimeout( ()=>{
                                if ( me.state.current == value ) {
                                    changeParams({[field]:value})
                                }
                            },1000)
                        } }
                    />
                </div>
                {message?<div className="invalid">{message}</div>:''}
            </>
        }
}